<template>
  <div>
    <b-form-input
      id="input-work-service"
      size="sm"
      :disabled="isDisabled"
      v-model="query"
      placeholder="Вид услуг"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"/>

    <b-list-group class="autocomplete-input-work-service" v-if="isFocus">
      <b-list-group-item v-for="(item, index) in items" :key="index" @mousedown="onClick(item)" button>
        {{ getItemListText(item) }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";

export default {
  name: "WorkServiceSelect",
  mixins: [ catalogs ],
  props: {
    isDisabled: Boolean,
    id: Number
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      filteredItems: null,// Передаются уже полученные значения WorkTypes
    }
  },
  methods: {
    async configure(id, filteredItems = null) {
      this.filteredItems = filteredItems;
      this.query = "";

      if (id > 0) {
        const item = (await this.getWorkServicesById(id)).data;
        if (item != null) {
          this.query = item.name;
          return;
        }
      }

      this.items = await this.getItems(this.query);
    },
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        this.items = await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClear() {
      this.query = '';
      this.$emit('onSelect', null);
    },
    onClick(item) {
      this.query = item.name;
      this.$emit('onSelect',item);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems(query) {
      if (this.filteredItems != null) {
        return this.filteredItems;
      }

      const data = {
        page: 1,
        size: 400,
        query: query
      }
      const result = await this.getWorkServicesSearch(data);
      if (result.data != null) {
        return result.data.items;
      } else {
        return [];
      }
    }
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query != null) {
          const queryLower = this.query.toLowerCase();
          this.items = await this.getItems(queryLower);
        }
      },
      deep: true
    },
    'id': {
      handler(newId, oldId) {
        if (newId !== oldId) {
          this.configure(newId);
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/* Autocomplete Select Input */
.autocomplete-input-work-service {
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
}

/* Autocomplete Select Input Group Item */
.autocomplete-input-work-service .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkServices/WorkServiceSelect.vue